export default "__VITE_ASSET__8d0a2b6e__"